var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"appointment-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.createAppointment()}}},[_c('frm-icon',{staticClass:"appointment-button__icon",attrs:{"name":"plus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }